'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _isHotkey = require('is-hotkey');

var _MarkStrategy = require('../strategies/MarkStrategy');

var _MarkStrategy2 = _interopRequireDefault(_MarkStrategy);

var _ColorStrategy = require('../strategies/ColorStrategy');

var _ColorStrategy2 = _interopRequireDefault(_ColorStrategy);

var _TopicColors = require('../TopicColors');

var _TopicColors2 = _interopRequireDefault(_TopicColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var markHotkeys = Object.entries({
  bold: (0, _isHotkey.isKeyHotkey)('mod+b'),
  italic: (0, _isHotkey.isKeyHotkey)('mod+i'),
  underline: (0, _isHotkey.isKeyHotkey)('mod+u')
});

var colorHotkeys = Object.entries(_TopicColors2.default).filter(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      color = _ref2[0],
      colorProps = _ref2[1];

  return colorProps.hotkey;
}).map(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      color = _ref4[0],
      colorProps = _ref4[1];

  return [color, (0, _isHotkey.isKeyHotkey)(colorProps.hotkey)];
});

var lastColorHotkey = (0, _isHotkey.isKeyHotkey)('mod+shift+x');

var KeyPlugin = function KeyPlugin() {
  return {
    onKeyDown: function onKeyDown(event, data, editor) {
      var markMatch = markHotkeys.find(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            mark = _ref6[0],
            hotkey = _ref6[1];

        return hotkey(event);
      });
      if (markMatch) {
        event.preventDefault();
        return editor.onChange((0, _MarkStrategy2.default)(editor.state.value, markMatch[0]));
      }

      var colorMatch = colorHotkeys.find(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            mark = _ref8[0],
            hotkey = _ref8[1];

        return hotkey(event);
      });
      if (colorMatch) {
        event.preventDefault();
        return editor.onChange((0, _ColorStrategy2.default)(editor.state.value, colorMatch[0]));
      }

      if (lastColorHotkey(event)) {
        event.preventDefault();
        return editor.onChange((0, _ColorStrategy2.default)(editor.state.value));
      }

      return null;
    }
  };
};

exports.default = KeyPlugin;